
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTwitterBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 26,
  viewBox: "0 0 32 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.882 2c1.642 0 3.505.652 4.55 1.738a11.639 11.639 0 0 0 3.623-1.352 5.615 5.615 0 0 1-2.51 3.083 11.668 11.668 0 0 0 3.28-.879 11.493 11.493 0 0 1-2.849 2.887c.01.238.016.478.016.718C26.992 15.562 21.45 24 10.944 24c-3.224 0-6.432-.867-8.957-2.449.446.054.901.08 1.361.08 2.676 0 5.14-.891 7.096-2.389-2.502-.043-4.612-1.656-5.336-3.869.347.064.707.1 1.075.1.518 0 1.025-.067 1.503-.196-2.613-.509-4.58-2.763-4.58-5.464V9.74c.77.418 1.65.67 2.586.7-1.533-1.003-2.54-2.706-2.54-4.641 0-1.022.281-1.981.772-2.801 2.816 3.369 7.026 5.59 11.774 5.824a5.407 5.407 0 0 1-.15-1.269c0-3.08 2.178-5.553 5.334-5.553Zm8.943 2.59h.005-.005ZM20.882 0c-3.844 0-6.817 2.753-7.263 6.552-3.189-.647-6.09-2.348-8.174-4.841a1.982 1.982 0 0 0-3.224.255 7.472 7.472 0 0 0-.59 6.434 2.006 2.006 0 0 0-.513 1.34v.073c0 1.959.77 3.776 2.047 5.139-.073.342-.057.703.055 1.046a7.54 7.54 0 0 0 2.284 3.398 9.884 9.884 0 0 1-3.277.169 1.988 1.988 0 0 0-2.114 1.321c-.31.884.032 1.867.824 2.363C3.77 25.023 7.323 26 10.944 26c6.84 0 11.086-3.157 13.444-5.805 2.86-3.211 4.524-7.477 4.59-11.74a13.45 13.45 0 0 0 2.437-2.663c.251-.334.4-.751.4-1.202 0-.681-.337-1.282-.852-1.644a2.01 2.01 0 0 0-.655-2.113 1.982 1.982 0 0 0-2.247-.179 9.529 9.529 0 0 1-2.125.908C24.56.592 22.693 0 20.882 0Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"32\" height=\"26\" viewBox=\"0 0 32 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M20.8824 2C22.5244 2 24.3874 2.652 25.4314 3.738C26.7294 3.486 27.9544 3.025 29.0554 2.386C28.6304 3.687 27.7234 4.779 26.5454 5.469C27.6984 5.332 28.8024 5.035 29.8254 4.59C29.0594 5.707 28.0924 6.69 26.9764 7.477C26.9864 7.715 26.9924 7.955 26.9924 8.195C26.9924 15.562 21.4504 24 10.9444 24C7.72042 24 4.51242 23.133 1.98742 21.551C2.43342 21.605 2.88842 21.631 3.34842 21.631C6.02442 21.631 8.48742 20.74 10.4444 19.242C7.94242 19.199 5.83242 17.586 5.10842 15.373C5.45542 15.437 5.81542 15.473 6.18342 15.473C6.70142 15.473 7.20842 15.406 7.68642 15.277C5.07342 14.768 3.10542 12.514 3.10542 9.813C3.10542 9.787 3.10542 9.764 3.10542 9.74C3.87642 10.158 4.75542 10.41 5.69242 10.44C4.15942 9.437 3.15242 7.734 3.15242 5.799C3.15242 4.777 3.43342 3.818 3.92442 2.998C6.74042 6.367 10.9504 8.588 15.6984 8.822C15.5994 8.414 15.5484 7.984 15.5484 7.553C15.5484 4.473 17.7264 2 20.8824 2ZM29.8254 4.59H29.8304H29.8254ZM20.8824 0C17.0384 0 14.0654 2.753 13.6194 6.552C10.4304 5.905 7.52942 4.204 5.44542 1.711C5.06642 1.257 4.50842 0.998 3.92442 0.998C3.87242 0.998 3.82042 1 3.76842 1.004C3.12842 1.055 2.55242 1.413 2.22142 1.966C1.53042 3.122 1.16442 4.447 1.16442 5.799C1.16442 6.7 1.32642 7.579 1.63042 8.4C1.30542 8.762 1.11842 9.238 1.11842 9.74V9.813C1.11842 11.772 1.88742 13.589 3.16542 14.952C3.09242 15.294 3.10842 15.655 3.22042 15.998C3.66242 17.348 4.46442 18.51 5.50442 19.396C4.80542 19.552 4.08442 19.631 3.34842 19.631C2.95942 19.631 2.58242 19.609 2.22742 19.565C2.14642 19.556 2.06642 19.551 1.98642 19.551C1.15342 19.551 0.39642 20.078 0.11342 20.886C-0.19658 21.77 0.14542 22.753 0.93742 23.249C3.76942 25.023 7.32342 26 10.9444 26C17.7834 26 22.0304 22.843 24.3884 20.195C27.2484 16.984 28.9124 12.718 28.9774 8.455C29.9044 7.682 30.7224 6.79 31.4154 5.792C31.6664 5.458 31.8154 5.041 31.8154 4.59C31.8154 3.909 31.4784 3.308 30.9634 2.946C31.1864 2.176 30.9304 1.342 30.3084 0.833C29.9454 0.537 29.5014 0.386 29.0544 0.386C28.7134 0.386 28.3704 0.474 28.0614 0.654C27.3964 1.04 26.6854 1.344 25.9364 1.562C24.5604 0.592 22.6934 0 20.8824 0Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/twitter-black.4cf8aa72109cd0f0a1998be849400d27.svg"),
        {
          React: SvgTwitterBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      